import { ModuleWithProviders, NgModule } from '@angular/core';
import { merge } from 'lodash';
import { FilterEngineSettings } from './models';
import { AbstractUserPreferencesFavoriteFilterEngineService } from './services/abstract-user-preferences-favorite-filter-engine.service';
import { FILTER_ENGINE_V2_SETTINGS, FilterEngineSettingsService } from './services/filter-engine-settings.service';
import { FilterEngineV2Store } from './state/filter-engine-v2.store';

@NgModule({
  providers: [FilterEngineSettingsService, FilterEngineV2Store]
})
export class FilterEngineV2Module {
  private static currentSettings: Partial<FilterEngineSettings> = {};

  static withSettings(settings: Partial<FilterEngineSettings>): ModuleWithProviders<FilterEngineV2Module> {
    if (settings) {
      this.currentSettings = merge(this.currentSettings, settings);
    }
    const providers = [];
    if (settings?.userPreferencesService) {
      providers.push({
        provide: AbstractUserPreferencesFavoriteFilterEngineService,
        useClass: settings.userPreferencesService
      });
    }
    return {
      ngModule: FilterEngineV2Module,
      providers: [
        ...providers,
        {
          provide: FILTER_ENGINE_V2_SETTINGS,
          useValue: {
            ...this.currentSettings
          }
        }
      ]
    };
  }
}
